/* global axios */
import ApiClient from './ApiClient';

class ActionPlansAPI extends ApiClient {
  constructor() {
    super('action_plans', { accountScoped: true });
  }

  getPlans(params = {}) {
    return axios.get(this.url, { params });
  }

  create(data) {
    return axios.post(this.url, data);
  }

  complete(planId) {
    return axios.post(`${this.url}/${planId}/complete`);
  }

  destroy(planId) {
    return axios.delete(`${this.url}/${planId}`);
  }
}

export default new ActionPlansAPI();
